import { useState, useEffect } from "react"
import Table from "./ui/Table"
import useAlerts from "../hooks/useAlerts"
import { useProject } from "../context/project"
import { MenuItem } from '@mui/material'
import styles from './visualization-dropdown/Alert.module.scss'
import AlertMenu from "./AlertMenu"

const emptyTable = ([{            
    dataset:'',
    column:'',
    alertType: {change:'', frequency: ''},
    uuid: '',
    operation: {uuid: ''}
}])

export default function AlertsTable({setAlertToEdit, openAlertWindow}) {
    const { alertsData } = useProject()
    const { removeAlert, alertTypeFormat } = useAlerts()
    const [tableData, setTableData] = useState([])

    useEffect(()=>{
        alertsData.length ? createDataForTable(alertsData) : setTableData(emptyTable)
        return () => setTableData([])
    }, [alertsData])

    const createDataForTable = (alertsData) => {
        const table = alertsData?.map(alert => ({
            dataset:alert.datasetName,
            column:alert.columnName,
            alertType: {change: alert.change, frequency: alert.time_period},
            uuid: alert.uuid,
            operations: alert
        }))
        setTableData(table)
    }

    const removeAlertFunction = (alertUUID, setAnchorEl) => {
        removeAlert(alertUUID)
        createDataForTable(alertsData.filter(alert => alertUUID !== alert.uuid))
        setAnchorEl(false)
    }

    const openEditAlerts = (alert) => {
        setAlertToEdit(alert)
        openAlertWindow()
    }

    const menuItems = (alert, setAnchorEl) => (
        <div>
            <MenuItem data-testid={`edit_${alert.uuid}`} key={`${alert.uuid}_edit`} onClick={() => openEditAlerts(alert)}>Edit</MenuItem>
            <MenuItem data-testid={`remove_${alert.uuid}`} key={`${alert.uuid}_delete`} onClick={() => removeAlertFunction(alert.uuid, setAnchorEl)}>Remove</MenuItem>
        </div>
    )
    
    const tableColumns = [
        {label: 'Dataset', id:'dataset', type: 'string', format: (value) => value},
        {label: 'Column', id: 'column', type: 'string', format: (value) => value},
        {label: 'Alert Type', id: 'alertType', type: 'object', format: alertTypeFormat},
        {label: '', id: 'operations', type: 'object', format: (value) => value.uuid && <AlertMenu menuItems={menuItems} alert={value}/>},
    ]

    return (
        <div className={styles["table-container"]}>
            <Table columns={tableColumns} rows={tableData} rowsPerPage={5}/>
        </div>
    )
}